module.exports = {
    baseUrl: process.env.NODE_ENV !== 'development'?`${window.location.protocol}//${window.location.host}/api/`: process.env._BASEURL,
    // fileUrl: process.env.NODE_ENV !== 'development'?`${window.location.protocol}//${window.location.host}/upload/`: process.env._FILEURL,
    fileUrl: (process.env.NODE_ENV !== 'development'&&window.location.host.indexOf('sit')<0?'http://crs-k8.sf-express.com/upload/': `${window.location.protocol}//${window.location.host}/upload/`),
    quesUrl: process.env.NODE_ENV !== 'development'?`${window.location.protocol}//${window.location.host}/`: process.env._QUESURL,
    quesId: process.env.NODE_ENV === 'production'?'321075172521373696':'320684381387026432',
    personInfo: {},
    userName: '',
    qrCodebaseUrl: process.env.NODE_ENV === 'production'?"https://crs-k8.sf-express.com/upload/":"http://crs-k8.sit.sf-express.com/upload/",
    //路径中参数（wechat）
    urlLoginType:'',// 是否是梦想驿站跳过去的 dreamLogin
    urlCode: '',
    urlChannel: '',
    urlState: '',
    glNoSeason: '',
    searchValue: '',
    offerAcceptedInfo:{
        offerAccepted:null,
       // openIdBinded:null, // 【！】是否绑定不用，因为微信菜单链接每次都会申请授权，都会传code过去
    },// 是否接收offer和是否保存openId信息 {offerAccepted: false;openIdBinded: false}
    isAndroid:'',
}



// WEBPACK FOOTER //
// ./src/store/global/state.js